import { ILogger } from '@cian/logger';
import { ITelemetryLogger } from '@cian/telemetry/shared';
import * as React from 'react';

import { ETelemetryEvents } from '../../types/telemetry';
import { ChatsErrorPage } from '../ChatsErrorPage';

interface ILoadableErrorBoundaryProps {
  telemetry: ITelemetryLogger;
  logger: ILogger;
  children: React.ReactNode;
}

interface ILoadableErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ILoadableErrorBoundaryProps, ILoadableErrorBoundaryState> {
  public state: ILoadableErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): ILoadableErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    const { telemetry, logger } = this.props;

    if (telemetry) {
      telemetry.increment(ETelemetryEvents.ChatPageCrashFail);
    }

    if (logger) {
      logger.error(error, {
        domain: 'src/shared/components/ErrorBoundary/ErrorBoundary.tsx',
        message: 'application crashed',
        ...info,
      });
    }
  }

  public render() {
    if (this.state.hasError) {
      return <ChatsErrorPage onRetry={this.handleRetryClick} />;
    }

    return this.props.children;
  }

  private handleRetryClick = () => {
    window.location.reload();

    this.setState({
      hasError: false,
    });
  };
}
